import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomSelectInput } from '../../utilComponents/inputs/CustomSelectInput';
import { CustomInput } from '../../utilComponents/inputs/CustomInput';
import { PhoneInput } from '../../utilComponents/inputs/PhoneInput';
import { validateInput } from '../../../helpers/validateInput';

export const ClientInformationStep = ({ form, handleUpdateForm, fullName }) => {
    const [touchedFields, setTouchedFields] = useState({});

    const validateField = (name, value) => {
        return validateInput(name, value, form);
    };

    const handleFieldChange = (field, value) => {
        handleUpdateForm(field, value);
        setTouchedFields({ ...touchedFields, [field]: true });
    };

    return (
        <Box mb={4}>
            <Typography variant="h6" sx={{ marginBottom: '10px' }}>
                Paso 1: Información del Cliente
            </Typography>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '20px',
                }}
            >
                <CustomSelectInput
                    label="Referencia"
                    value={form.reference}
                    onChange={e =>
                        handleFieldChange('reference', e.target.value)
                    }
                    error={
                        touchedFields.reference &&
                        !!validateField('reference', form.reference)
                    }
                    helperText={
                        touchedFields.reference &&
                        validateField('reference', form.reference)
                    }
                    options={[
                        { value: 'COT', label: 'CONTACTO' },
                        { value: 'PRP', label: 'PROSPECTO' },
                        { value: 'LEA', label: 'LEAL' },
                        { value: 'CLI', label: 'CLIENTE' },
                    ]}
                />

                <CustomSelectInput
                    label="Tipo de Cliente"
                    value={form.clientType}
                    onChange={e =>
                        handleFieldChange('clientType', e.target.value)
                    }
                    error={
                        touchedFields.clientType &&
                        !!validateField('clientType', form.clientType)
                    }
                    helperText={
                        touchedFields.clientType &&
                        validateField('clientType', form.clientType)
                    }
                    options={[
                        { value: 'PIN', label: 'NUEVO' },
                        { value: 'PIR', label: 'RECUPERADO' },
                        { value: 'PIC', label: 'CAUTIVO' },
                        { value: 'NEW', label: 'NUEVO' },
                        { value: 'REC', label: 'RECUPERADO' },
                        { value: 'CAU', label: 'CAUTIVO' },
                    ]}
                />

                <CustomInput
                    label="Nombre del Cliente"
                    value={form.clientName}
                    onChange={({ target }) =>
                        handleFieldChange('clientName', target.value)
                    }
                    error={
                        touchedFields.clientName &&
                        !!validateField('clientName', form.clientName)
                    }
                    helperText={
                        touchedFields.clientName &&
                        validateField('clientName', form.clientName)
                    }
                />

                <CustomInput
                    label="Correo"
                    value={form.email}
                    onChange={({ target }) =>
                        handleFieldChange('email', target.value)
                    }
                    error={
                        touchedFields.email &&
                        !!validateField('email', form.email)
                    }
                    helperText={
                        touchedFields.email &&
                        validateField('email', form.email)
                    }
                />

                <PhoneInput
                    value={form.phone}
                    onChange={value => handleFieldChange('phone', value)}
                    error={
                        touchedFields.phone &&
                        !!validateField('phone', form.phone)
                    }
                    helperText={
                        touchedFields.phone &&
                        validateField('phone', form.phone)
                    }
                />

                <CustomInput
                    label="Asesor"
                    value={fullName}
                    InputProps={{ readOnly: true }}
                />

                <CustomSelectInput
                    label="Acción"
                    value={form.action}
                    onChange={e => handleFieldChange('action', e.target.value)}
                    error={
                        touchedFields.action &&
                        !!validateField('action', form.action)
                    }
                    helperText={
                        touchedFields.action &&
                        validateField('action', form.action)
                    }
                    options={[
                        { value: 'LLA', label: 'LLAMADA' },
                        { value: 'CRR', label: 'CORREO' },
                        { value: 'CIT', label: 'CITA' },
                        { value: 'CHA', label: 'CHAT' },
                        { value: 'VID', label: 'VIDEO' },
                        { value: 'ENC', label: 'EN CAMPO' },
                    ]}
                />
            </div>
        </Box>
    );
};
